import { ReactNode } from 'react';
import { AdminRouteId } from '../adminRoutes';

export function AdminNavIcon({ route }: { route: AdminRouteId }) {
  switch (route) {
    case 'home':
      return <Icon><path d="m3 10 9-7 9 7" /><path d="M5 9v11h14V9" /><path d="M9 20v-6h6v6" /></Icon>;
    case 'users':
      return <Icon><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Icon>;
    case 'companies':
      return <Icon><path d="M3 21h18" /><path d="M6 21V5l6-3v19" /><path d="M12 8h6v13" /><path d="M8.5 9h1M8.5 13h1M8.5 17h1M15 12h1M15 16h1" /></Icon>;
    case 'imports':
      return <Icon><path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" /></Icon>;
    case 'catalog':
      return <Icon><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5Z" /><path d="M4 5.5v16M8 7h8M8 11h8" /></Icon>;
    case 'delivery-zones':
      return <Icon><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></Icon>;
    case 'orders':
      return <Icon><path d="M5 3h14v18H5z" /><path d="M8 8h8M8 12h8M8 16h5" /></Icon>;
    case 'file-contexts':
    case 'files':
      return <Icon><path d="M6 2h8l4 4v16H6Z" /><path d="M14 2v5h5M9 13h6M9 17h6" /></Icon>;
    case 'queues':
      return <Icon><path d="M4 6h16M4 12h10M4 18h16" /><circle cx="18" cy="12" r="2" /></Icon>;
  }
}

function Icon({ children }: { children: ReactNode }) {
  return (
    <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
      {children}
    </svg>
  );
}
